// extracted by mini-css-extract-plugin
module.exports = {"container":"Overview_container__15vnM","title":"Overview_title__syx4R","text":"Overview_text__16xls"};